<template>
    <b-form-group
        :label-for="id"
        :invalid-feedback="errors"
        :state="errors ? false : null">
        <template slot="label">
            {{ label }} <i  v-b-tooltip.hover.right :title="iconTooltip" class="fa-solid fa-lg" :class="{ 'fa-circle-o fa-beat-fade text-danger': isListening, 'fa-circle-microphone text-primary': !isListening }" @click="toggleListening"></i>
        </template>
        <b-form-textarea v-bind="$attrs" trim :id="id" :class="classes" :state="state" v-model="transcript" @input="updateValue" @change="onChange" />

        <slot></slot>

    </b-form-group>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
    props: ['id', 'label', 'errors', 'value', 'state', 'classes'],
    inheritAttrs: false,
    data() {
        return {
            isListening: false,
            transcript: '',
            debouncedUpdate: null
        }
    },
    computed: {
        iconTooltip() {
            return this.isListening ? 'Click to stop voice input' : 'Click to start voice input (BETA)'
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.transcript = val
            }
        }
    },
    methods: {
        toggleListening() {
            this.isListening = !this.isListening
            if (this.isListening) {
                try {
                    this.$speechRecognition.initialize(this.speechLang) // Adjust language as needed
                    this.$speechRecognition.start(this.handleResult, this.onEnd)
                } catch (error) {
                    this.isListening = false
                }
            } else {
                this.$speechRecognition.stop()
            }
        },
        handleResult(transcript) {
            this.transcript = transcript
            this.updateValue() // Emit updated value
        },
        onEnd() {
            this.isListening = false
        },
        updateValue() {
            // this.clearDebounce()
            this.$emit('input', this.transcript)
            // this.debouncedUpdate = debounce(this.onChange, 5000)
            // this.debouncedUpdate()
        },
        onChange() {
            this.$emit('input', this.transcript)
            // this.$emit('change', this.transcript)
        },
        clearDebounce() {
          this.debouncedUpdate.cancel()
          this.debouncedUpdate = null
        },
    },
    created() {
        // Initialize the debounced function in the correct context
        // this.debouncedUpdate = debounce(this.onChange, 5000)
    },
    beforeDestroy() {
        if (this.isListening) {
            this.$speechRecognition.stop()
        }
        // this.debouncedUpdate.cancel()
        // this.debouncedUpdate = null
    }
}
</script>
